module.exports = __webpack_public_path__ + "static/media/anita-hayley.7bec55f6.svg";